import { render, staticRenderFns } from "./review-category-list-element.vue?vue&type=template&id=acfa45f6&scoped=true"
import script from "./review-category-list-element.vue?vue&type=script&lang=js"
export * from "./review-category-list-element.vue?vue&type=script&lang=js"
import style0 from "./review-category-list-element.vue?vue&type=style&index=0&id=acfa45f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfa45f6",
  null
  
)

export default component.exports